<!-- PC 页的播放器 -->
<template>
  <div :class="['player', { 'player-in-room': inRoom }]">
    <div
      id="player-live"
      :class="['player-live', { 'is-full-screen': isFullScreen }]"
    >
      <video
        id="liveVideo"
        class="video-js vjs-big-play-centered"
        :poster="require('@/assets/img/video-bg.png')"
        playsinline
        webkit-playsinline
        controls
      >
        <div class="vjs-poster-bg"></div>
      </video>
      <!--      弹幕-->
      <canvas v-show="showDanmu" id="bigo_danmu_e" class="bigo_danmu"></canvas>
      <div id="bigo_dom_danmu_e" class="bigo_dom_danmu"></div>
      <div class="gift_animation_box">
        <ul id="gift_animation_e" class="gift_animation"></ul>
        <div class="screen_gift_box">
          <div class="screen_gift_cell">
            <img
              id="screen_gift_tag_e"
              class="screen_gift_tag"
              :src="require('~/assets/img/giftbg/screenImg.png')"
              alt="screen_gift_tag"
            />
          </div>
        </div>
      </div>
      <!--      未开播-->
      <div v-if="status === 'offLive'" class="live--off">
        <div class="live--off__container">
          <img
            v-if="!liveInfo.passRoom"
            :src="require('~/assets/img/ohno.png')"
          />
          {{ $t('lang090') }}
        </div>
      </div>
      <div v-else-if="status === 'end'" class="live--end">
        <div class="end__container">
          <div class="end__top">
            <div class="end-title">{{ $t('lang173') }}</div>
            <!-- <div class="end-live-long">{{ getFormatTime(endTotalTime) }}</div> -->
          </div>
          <div class="end__center">
            <div
              class="end-avatar"
              :style="{ backgroundImage: `url(${avatar})` }"
            ></div>
            <div class="end-nickname">{{ liveInfo.nick_name }}</div>
            <div class="end-bigoid">ID:{{ bigoid }}</div>
          </div>
          <div class="end__bottom">
            <div class="end-viewers">{{ nums }}</div>
            <div class="end-viewers-text">viewers</div>
          </div>
        </div>
      </div>
      <!-- 密码房 -->
      <div v-if="showPasswordCover" class="password-room">
        <div v-if="showPasswordCover === 1" class="password-room_container">
          <div class="password-room_desc">{{ $t('lang327') }}</div>
          <button
            class="password-room_enter-btn"
            @click="$emit('multiPersonClick')"
          >
            {{ $t('lang328') }}
          </button>
        </div>
        <div
          v-else-if="showPasswordCover === 2"
          class="password-room__container"
        >
          <div class="password-room_desc">
            {{ $t('lang325') }}
          </div>
          <input
            v-model="password"
            type="number"
            maxlength="6"
            :placeholder="$t('lang334')"
            class="password-room_input"
            @keyup.enter="verifyPassword"
          />
          <button
            :class="[
              'password-room_enter-btn',
              { disable: password.length < 6 }
            ]"
            @click="verifyPassword"
          >
            {{ $t('lang326') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PlayerCreator from './playerCreator';
import { setCookie, getCookie } from '~/assets/js/utils';
import { endLive } from '~/assets/js/player/store/action';
import { resetInfo } from '~/assets/js/player/store/mutation';
import state from '~/assets/js/player/store/state';
import { getLiveConfig } from '~/assets/js/player/assets/js/utils';
import PlayerWs from '~/components/Player/playerWs';
import { reportToHive, debugReportToHive } from '~/assets/js/player/report';
import api from '~/services';

const ONE_MINUTE = 60;
const ONE_HOUR = ONE_MINUTE * 60;

/* eslint-disable camelcase */

// function random(min, max) {
//   return Math.floor(Math.random() * (max - min)) + min;
// }

if (process.client) {
  // 曝光
  window.addEventListener('load', function() {
    const start = performance.timing.navigationStart;
    reportToHive.reportEnter(performance.timing.domComplete - start);
  });

  // window.addEventListener('beforeunload', function() {
  //   const start = performance.timing.navigationStart;
  //   reportToHive.reportLeave(Date.now() - start);

  //   debugReportToHive.report();
  // });
}
let debugReportToHiveObj = {};

export default {
  props: {
    current: {
      type: Object,
      require: true,
      default: () => ({})
    },
    controlLayout: {
      type: String,
      default: 'volume,rotate,full-screen,enter-room'
    },
    showEnterRoom: {
      type: Boolean,
      default: false
    },
    showDanmuBtn: {
      type: Boolean,
      default: false
    },
    inRoom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullScreen: false,
      status: 'init',
      // 当前主播bigoid
      bigoid: null,
      // 结束时的开播时长
      endTotalTime: 0,
      // PlayerCreator的实例
      creator: null,
      nums: 0,
      // 密码房遮罩层，0: 隐藏 1: 多人密码房 2: 单人密码房
      showPasswordCover: 0,
      password: '',
      options: {},
      ...state
    };
  },
  computed: {
    ...mapState(['showDanmu']),
    avatar() {
      return this.liveInfo.avatar || require('~/assets/img/default-avatar.png');
    },
    muted() {
      return this.playerInfo.muted;
    },
    logoImg() {
      return getLiveConfig(this.liveInfo.app)?.logoImg;
    },
    appearClass() {
      let text = '';
      if (!this.viewInfo.appear) {
        text = 'disappear';
      }
      return text;
    }
  },
  watch: {
    password(val, preVal) {
      if (Object.is(+val, NaN)) {
        this.password = preVal;
      }
      this.password = val.slice(0, 6);
    }
  },
  mounted() {
    debugReportToHiveObj = debugReportToHive();
  },
  beforeDestroy() {
    this.ws && this.ws.destroy();
    if (this.creator) {
      this.creator.destroy();
    }

    const start = performance?.timing?.navigationStart;
    reportToHive.reportLeave(Date.now() - start);

    debugReportToHiveObj.report();
  },
  methods: {
    async verifyPassword() {
      if (this.password.length < 6) return;
      if (navigator.onLine === false) {
        this.$toast('Network Offline');
        return;
      }

      const res = await this.$api.getInternalStudioInfo({
        siteId: this.liveInfo.siteid,
        verify: this.password
      });
      if (res.code === 0) {
        const { data } = res;
        // 保存主播信息
        this.liveInfo = {
          ...this.liveInfo,
          ...data,
          password: this.password
        };

        if (data.alive === 1) {
          const src = data.hls_src;
          this.videoInfo.hlsSrc = src;
          this.videoInfo.videoSrc = src;
        }
        this.initPlayer();
        this.showPasswordCover = 0;
        const lastCookie = getCookie(`${this.options.siteid}-psw`);
        setCookie(`${this.options.siteid}-psw`, this.password || lastCookie);
        this.$hive.send('011201002', {
          action: 2,
          showeruid: this.bigoid,
          userId: this.ws?.wsConfig?.userId
        });
      } else if (res.code === 810021) {
        this.$toast(
          typeof this.$t('lang333') === 'string' &&
            this.$t('lang333').replace('[001]', res.msg)
        );
      } else if (res.code === 810022) {
        this.$toast(this.$t('lang332'));
      }
    },
    getFormatTime(time) {
      if (typeof time !== 'number') {
        console.log('time is not a number');
        return time;
      }
      if (!time || time <= 0) {
        return '00:00:00';
      }

      let rest = time;
      const hrs = Math.floor(rest / ONE_HOUR);
      rest -= hrs * ONE_HOUR;
      const min = Math.floor(rest / ONE_MINUTE);
      rest -= min * ONE_MINUTE;
      const sec = rest;

      function formatNum(num) {
        return num >= 10 ? num : `0${num}`;
      }
      return `${formatNum(hrs)}:${formatNum(min)}:${formatNum(sec)}`;
    },
    gotoRoom() {
      const bigoid =
        this.current.bigo_id || this.current.bigoID || this.current.bigoid;
      this.$router.push(this.localePath(`/${bigoid}`));
    },
    // 获取主播信息
    async getInfo(options) {
      this.options = options;
      this.times.t2 = Date.now();
      this.liveInfo.app = options.app;
      this.liveInfo.siteid = options.siteid;
      this.bigoid = options.siteid;

      const password = getCookie(`${options.siteid}-psw`);

      const { code, data } = await api.getInternalStudioInfo({
        siteId: options.siteid,
        verify: password
      });
      if (code === 810021) {
        // getInfo 返回 810021 说明从 cookie 取出的密码是错的
        // 可能是主播更新了密码，讲 cookie 清除再调用 getInfo
        setCookie(`${options.siteid}-psw`, '');
        this.getInfo(this.options);
      }
      if (code !== 0) return;

      this.password = password;
      this.liveInfo.password = password;
      // 多人密码房
      if (data.passRoom && data.roomStatus === 4) {
        this.showPasswordCover = 1;
      } else if (data.passRoom && !data.hls_src && data.alive) {
        this.showPasswordCover = 2;
      }

      this.times.t3 = Date.now();

      // 保存主播信息
      this.liveInfo = {
        ...this.liveInfo,
        ...data
      };

      if (data.alive === 1) {
        const src = data.hls_src;
        this.videoInfo.hlsSrc = src;
        this.videoInfo.videoSrc = src;
      }

      return data;
    },
    startWs() {
      // 开启websocket
      this.ws = new PlayerWs(this.liveInfo, this.$log);
      this.subWs(this.ws);
      this.ws.init({ password: this.password });
    },
    initCreator() {
      const creator = new PlayerCreator('liveVideo');
      creator.start(this.videoInfo.videoSrc);
      this.creator = creator;
    },
    initPlayer() {
      this.initCreator();

      setTimeout(() => {
        if (this.showEnterRoom) {
          // 新增进入直播间按钮
          this.createEnterRoomBtn();
        }

        if (this.showDanmuBtn) {
          // 弹幕开关
          this.createDanmuBtn();
        }

        if (!window.videojs.browser.IE_VERSION) {
          // 定制全屏按钮，为了全屏时可以看到弹幕
          this.createFullScreenBtn();
        }

        // 增加上层poster
        this.createUpperPoster();

        this.times.t4 = Date.now();
        this.status = 'living';
        this.startWs();

        // 通知公屏
        this.$emit('finishInitLive', {
          liveInfo: this.liveInfo,
          ws: this.ws
        });
      }, 500);
    },
    async startLive(options) {
      await this.getInfo(options);

      const { passRoom, alive, hls_src } = this.liveInfo;
      // 密码房没验证密码不做播放器初始化
      if (passRoom && alive && !hls_src) return;

      if (alive === 1) {
        this.initPlayer();
      } else {
        this.status = 'offLive';
        this.$emit('endLive', {
          liveInfo: this.liveInfo
        });
        endLive();
      }
    },
    async switchLive(options) {
      this.ws && this.ws.destroy();
      resetInfo();

      await this.getInfo(options);
      if (this.liveInfo.alive === 1) {
        if (!this.creator || !this.creator.player) {
          this.initCreator();
        }
        this.creator.switch(this.videoInfo.videoSrc);

        this.times.t4 = Date.now();
        this.status = 'living';

        this.startWs();

        // 通知公屏
        this.$emit('finishInitLive', {
          liveInfo: this.liveInfo,
          ws: this.ws
        });
      } else {
        this.status = 'offLive';
        endLive();
      }
    },
    triggerDanmu() {
      this.$store.commit('update_showDanmu');
      const btnDanmu = document.querySelector('.danmu_switch_box');
      if (this.showDanmu) {
        btnDanmu.classList.remove('status_off');
      } else {
        btnDanmu.classList.add('status_off');
      }
    },
    triggerFullScreen() {
      const playerLive = document.querySelector('#player-live');
      if (this.isFullScreen) {
        this.creator.player.exitFullscreen();
      } else {
        try {
          /* eslint-disable-next-line */
          if (playerLive.requestFullscreen) {
            return playerLive.requestFullscreen();
          } else if (playerLive.webkitRequestFullScreen) {
            return playerLive.webkitRequestFullScreen();
          } else if (playerLive.mozRequestFullScreen) {
            return playerLive.mozRequestFullScreen();
          } else if (playerLive.msRequestFullscreen) {
            playerLive.msRequestFullscreen();
          } else {
            this.creator.player.requestFullscreen();
          }
        } catch (err) {
          console.log(err);
          this.creator.player.requestFullscreen();
        }
      }
    },
    createEnterRoomBtn() {
      const player = this.creator.player;

      if (!player) {
        return;
      }
      const enterRoomBtn = player.controlBar.addChild('button', {
        clickHandler: this.gotoRoom
      });
      enterRoomBtn.addClass('vjs-enter-room');
      enterRoomBtn.el().innerHTML = 'Enter the Live Room';
    },
    createDanmuBtn() {
      const player = this.creator.player;
      if (!player) {
        return;
      }
      const danmuBtn = player.controlBar.addChild('button', {
        clickHandler: this.triggerDanmu
      });
      danmuBtn.addClass('danmu_switch_box');
    },
    createFullScreenBtn() {
      const player = this.creator.player;
      if (!player) {
        return;
      }
      const btn = player.controlBar.addChild('button', {
        clickHandler: this.triggerFullScreen
      });
      btn.addClass('vjs-fullscreen-control');
      btn.addClass('vjs-control');
      btn.addClass('vjs-button');

      const playerLive = document.querySelector('#player-live');
      [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange'
      ].forEach((fullScreenCHange) => {
        playerLive.addEventListener(fullScreenCHange, (e) => {
          this.isFullScreen = !this.isFullScreen;
        });
      });
    },
    createUpperPoster() {
      if (!this.current.data5) return;

      const player = this.creator.player;
      if (!player) {
        return;
      }
      const posterCover = player.posterImage.addChild('component');
      posterCover.addClass('vjs-poster-cover');
      posterCover.el().style.backgroundImage = `url(${this.current.data5})`;

      const posterOpa = player.posterImage.addChild('component');
      posterOpa.addClass('vjs-poster-opa');
      posterOpa.el().style.backgroundImage = `url(${this.current.cover_url ||
        this.current.data5})`;
    },
    subWs(ws) {
      ws.sub(3608, (msg) => {
        const { roomStatus } = msg;
        // roomStatus; 0->正在直播，1->正常退出，2->封退, 3->暂时离开, 4->回来, 5->表示告警封退
        if (roomStatus === '1' || roomStatus === '5') {
          PlayerWs.log('结束直播！');
          // 直播结束不销毁，防止首页banner中有直播下播，<video>被销毁无法播放下一个直播
          // this.creator.destroy();
          this.status = 'end';
          this.showPasswordCover = 0;
          // this.endTotalTime = data?.totalTime || 0;
          ws.send('7|24', {
            seqId: String(~~(+new Date() / 1000)),
            roomId: this.liveInfo.roomId
          });
        } else if (roomStatus === '4') {
          PlayerWs.log('主播暂离回来！');
          this.creator.play();
          this.status = 'living';
          reportToHive.reportError('hostBackRestart');
        } else if (roomStatus === '3') {
          PlayerWs.log('主播暂离！');
          this.creator.pause();
          this.status = 'leave';
        } else {
          //  todo 其他应该是什么状态
        }
      });
      ws.sub(PlayerWs.EVENT.NUMS, (msg) => {
        // 观众人数更新
        if (`${this.liveInfo.roomId}` === msg.gid) {
          this.nums = msg.totalUserCount;
        } else {
          PlayerWs.log('roomid不对，bigo观众数不更新');
        }
      });
      ws.sub('WS_INIT_FINISH', () => {
        if (this.liveInfo.passRoom) {
          this.$hive.send('011201002', {
            action: 1,
            showeruid: this.bigoid,
            userId: this.ws?.wsConfig?.userId
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.video-bg {
  background-image: url('~@/assets/img/video-bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.player {
  width: 1114px;
  position: relative;
  height: 628px;
  overflow: hidden;
  border-radius: 4px;

  .player-live {
    width: 100%;
    height: 100%;
    position: relative;

    &.is-full-screen {
      .video-js .vjs-fullscreen-control .vjs-icon-placeholder::before {
        content: '\f109';
      }
    }

    .bigo_danmu {
      position: absolute;
      left: 0;
      top: 0;
      background: transparent;
      filter: alpha(opacity=70);
      opacity: 0.7;
    }

    .live--no-autoplay {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: url('~@assets/img/big-play.png') center no-repeat;
      background-size: contain;
      width: 120px;
      height: 120px;
      cursor: pointer;
    }

    .live--off {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      @extend .video-bg;

      &__container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        text-align: center;
        font-size: 36px;
        color: #fff;
        width: 100%;
      }
    }

    .live--end {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
      background-image: url(~@assets/img/video_bg.png);
      background-size: 100% 100%;

      .end__container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 350px;
        text-align: center;
      }

      .end__center {
        margin-top: 50px;
      }

      .end__bottom {
        margin-top: 50px;
      }

      .end-title {
        font-size: 42px;
        color: #fff;
        font-weight: normal;
      }

      .end-live-long {
        font-size: 16px;
        color: #aa9a9a;
      }

      .end-avatar {
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border: 6px #6c5d56 solid;
        overflow: hidden;
        border-radius: 112px;
        background: center no-repeat;
        background-size: cover;
      }

      .end-nickname {
        font-size: 26px;
        color: #fff;
        font-weight: normal;
      }

      .end-bigoid {
        font-size: 16px;
        color: #999;
        line-height: 25px;
      }

      .end-viewers {
        font-size: 20px;
        color: #fff;
      }

      .end-viewers-text {
        font-size: 12px;
        color: #aa9a9a;
      }
    }

    .password-room {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 1;

      @extend .live--off;

      &__container {
        width: 300px;
      }

      &_desc {
        width: 100%;
        margin-bottom: 32px;
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
      }

      &_input {
        width: 300px;
        height: 48px;
        margin-bottom: 24px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      &_enter-btn {
        width: 300px;
        height: 48px;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        line-height: 21px;
        background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
        border-radius: 48px;

        &.disable {
          opacity: 0.7;
          cursor: default;
        }
      }
    }

    .video-js {
      width: 100%;
      height: 100%;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &.player-in-room {
    width: 989px;
    height: 567px;
  }
}

.pay_danmu_list {
  position: absolute;
  top: 10px;
  left: 100%;
  height: 34px;
  overflow: hidden;
  padding-right: 70px;
  -moz-transition: 12s left linear;
  -webkit-transition: 12s left linear;
  -o-transition: 12s left linear;
  transition: 12s left linear;
}

.pay_words {
  line-height: 34px;
  font-size: 24px;
  color: #fff;
  background: rgba(0, 221, 204, 0.75);
  border-top-left-radius: 34px;
  border-bottom-left-radius: 34px;
  text-indent: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shadow_bg {
  width: 70px;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 34px;
  /* 旧语法，带前缀并且已经废弃，以支持老版本的浏览器 */
  background: -prefix-linear-gradient(
    left,
    rgba(0, 221, 204, 0.75),
    rgba(0, 221, 204, 0)
  );
  /* 新语法，不带前缀，以支持标准兼容的浏览器（Opera 12.1， IE 10， Firefox 16， Chrome 26， Safari 6.1） */
  background: linear-gradient(
    to right,
    rgba(0, 221, 204, 0.75),
    rgba(0, 221, 204, 0)
  );
}

.player {
  .video-js {
    background-color: transparent;
    background-image: url('~@/assets/img/video-bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    font-size: 14px;

    .vjs-control-bar {
      background: rgba(#000, 0.5);
      z-index: 100;
    }

    .vjs-enter-room {
      padding: 0 2px;
      min-width: 12em;
      height: 2em;
      background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
      border-radius: 31px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      align-self: center;
      margin-right: 1em;
    }

    video {
      pointer-events: none;
    }

    .danmu_switch_box {
      position: relative;
      width: 45px;
      height: 20px;
      margin-top: 12px;
      margin-right: 1em;
      border-radius: 20px;
      border: 2px solid #fff;
      cursor: pointer;

      &::before {
        content: '';
        display: inline-block;
        position: relative;
        top: 1.3px;
        left: 11px;
        background: #0dc;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        transition: all 0.3s;
      }

      &.status_off::before {
        left: -11px;
        background: #fff;
      }
    }

    .vjs-poster-cover {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-size: cover;
      background-repeat: no-repeat;
      -webkit-filter: blur(5px);
      -moz-filter: blur(5px);
      -ms-filter: blur(5px);
      filter: blur(5px);
      filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=5, MakeShadow=false);
    }

    .vjs-poster-opa {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: center no-repeat;
      background-size: contain;
    }
  }

  // 大播放按钮
  .video-js .vjs-big-play-button {
    width: 1.5em;
    height: 1.5em;
    line-height: 1.5em;
    font-size: 6em;
    border-radius: 100%;
    border: none;
    background: url('~@/assets/img/video-big-play.png') center no-repeat;
    background-size: 100%;

    .vjs-icon-placeholder::before {
      content: '';
    }
  }

  .vjs-big-play-centered .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-left: -0.75em;
    margin-top: -0.75em;
    z-index: 100;
  }

  .video-js .vjs-big-play-button:focus,
  .video-js:hover .vjs-big-play-button {
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
    transition: all 0s;
  }
}

/* 礼物动画相关 */
.gift_animation_box {
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.gift_animation {
  position: absolute;
  z-index: 9;
  right: 0;
  bottom: 50px;
}

.gift_animation {
  position: absolute;
  z-index: 9;
  right: 0;
  bottom: 50px;
}
.gift_list {
  position: absolute;
  right: -310px;
  /*right: 10px;*/
  bottom: 50px;
  width: 284px;
  height: 73px;
  background-image: url('~@/assets/img/giftbg/hfall.png');
  background-size: 100% auto;
  background-position: 0 0;
  transition: 0.4s right;
}
.gift_list .thumb {
  width: 45px;
  height: 45px;
  overflow: hidden;
  border-radius: 45px;
  position: absolute;
  left: 0px;
  top: 14px;
}
.gift_list .thumb img {
  width: 100%;
  height: 100%;
  border-radius: 45px;
}
.gift_list .name {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
  position: absolute;
  left: 50px;
  top: 15px;
}
.gift_list .send_tips {
  position: absolute;
  left: 50px;
  top: 40px;
  color: #fff;
  font-size: 12px;
}
.gift_star_box {
  width: 48px;
  height: 9px;
  position: absolute;
  left: 120px;
  top: 53px;
}
.gift_list .gift_star {
  width: 12px;
  height: 9px;
  margin: auto;
  background: url('~@/assets/img/giftbg/star.png') left center no-repeat;
}
.gift_list .star1 {
  width: 12px;
}
.gift_list .star2 {
  width: 24px;
}
.gift_list .star3 {
  width: 36px;
}
.gift_list .star4 {
  width: 48px;
}
.movingLight_box {
  position: absolute;
  z-index: 9;
  top: 14px;
  left: 0;
  height: 45px;
  width: 245px;
  overflow: hidden;
  border-bottom-left-radius: 45px;
  border-top-left-radius: 45px;
}
.movingLight {
  position: absolute;
  left: -150px;
  /*left: -20px;*/
  top: 0;
  height: 100%;
  z-index: 9;
  filter: alpha(opacity=100);
  opacity: 1;
}
.movingLight.movingStatu {
  animation: movingLightAnimation 0.6s;
}
.gift_dressup {
  position: absolute;
  z-index: 1;
  width: 120px;
  height: 55px;
  left: 165px;
  top: -16px;
  background-position: 0 0px;
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.gift_dressup.dressupStatu0 {
  background-image: none;
}
.gift_dressup.dressupStatu1 {
  background-image: url('~@/assets/img/giftbg/combobg1.png');
  background-position: -28px 15px;
}
.gift_dressup.dressupStatu2 {
  background-image: url('~@/assets/img/giftbg/combobg2.png');
  background-position: -28px 15px;
}
.gift_dressup.dressupStatu3 {
  background-image: url('~@/assets/img/giftbg/combobg3.png');
  background-position: -28px 15px;
}
.gift_dressup.dressupStatu4 {
  background-image: url('~@/assets/img/giftbg/Fireworks.gif');
}
.gift_list .gift_icon {
  position: absolute;
  z-index: 2;
  left: 120px;
  top: 0px;
  height: 50px;
}
.combo_box {
  position: absolute;
  z-index: 2;
  left: 172px;
  top: 16px;
}
.combo_box .x_num {
  font-size: 18px;
  color: #fff;
  font-style: italic;
  transform-origin: 0 50%;
}
.combo_box .tips {
  color: #fbef00;
  font-weight: bold;
}
.combo_counter {
  position: absolute;
  left: 228px;
  top: 13px;
  width: 60px;
  height: 60px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  color: #fbef00;
  transform-origin: center;
  background-image: url('~@/assets/img/giftbg/combo.png');
  background-position: 60px 60px;
  background-repeat: no-repeat;
}
.combo_counter.countAnimation {
  animation: countAnimation 0.6s;
  -moz-animation: countAnimation 0.6s;
  -webkit-animation: countAnimation 0.6s;
  -o-animation: countAnimation 0.6s;
}
@keyframes countAnimation {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(3);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes movingLightAnimation {
  0% {
    filter: alpha(opacity=100);
    opacity: 1;
  }
  50% {
    filter: alpha(opacity=60);
    opacity: 0.6;
  }
  100% {
    filter: alpha(opacity=0);
    opacity: 0;
    left: 74%;
  }
}

@keyframes giftStartScaleNum {
  40% {
    transform: scale(1);
  }
  60% {
    transform: scale(3);
  }
  100% {
    transform: scale(1);
  }
}
.screen_gift_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 9;
  display: table;
}
.screen_gift_cell {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.screen_gift_tag {
  width: 100px;
  height: 100px;
  max-height: 80%;
  max-width: 80%;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% auto;
}
</style>
